export const styles = {
  root: (theme) => ({
    position: 'relative',
    backgroundColor: 'kit.background.white',
    zIndex: (theme) => theme.zIndex.appBar,
    borderRadius: 0,
    height: 60,

    [theme.breakpoints.down('md')]: { height: 48 },
  }),

  toolbar: (theme) => ({
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    padding: '0 60px',

    [theme.breakpoints.down('lg')]: { padding: '0 30px' },
    [theme.breakpoints.down('md')]: { padding: '0 16px' },
  }),

  elbrusLogoIcon: () => ({
    marginTop: '3px',
    width: '104px',
    height: '34px',
  }),

  navbar: (theme) => ({
    marginLeft: '166px',
    display: 'flex',
    alignItems: 'center',
    gap: '24px',

    [theme.breakpoints.down('lg')]: {
      marginLeft: 0,
    },

    [theme.breakpoints.down('md')]: {
      display: 'none',
    },
  }),

  navbarLinks: (location) => ({
    color: 'kit.link.main',
    textDecoration: `${location ? 'underline' : 'none'}`,
  }),

  link: {
    textDecoration: 'none !important',
    color: 'kit.link.main',
    fontSize: '14px',
  },

  lkButtonsWrapper: (theme) => ({
    display: 'flex',
    gap: '16px',
    marginLeft: 'auto',

    [theme.breakpoints.down('lg')]: {
      marginLeft: 0,
    },
  }),

  subheaderItem: () => ({
    '&:hover': {
      boxShadow: '8px 10px 10px rgba(147, 107, 255, 0.08)',
    },
  }),

  wrapper: (theme) => ({
    height: 46,

    [theme.breakpoints.down('lg')]: { height: '56px' },

    [theme.breakpoints.down('md')]: {
      mb: 0,
      paddingLeft: '4px',
      width: '100%',
      overflowX: 'scroll',
      overflowY: 'hidden',
      height: '52px',
      '::-webkit-scrollbar': {
        display: 'none',
      },
    },

    [theme.breakpoints.down('sm')]: {
      height: '45px',
      mb: 0,
      paddingLeft: '12px',
    },
  }),

  chevronIcon: (isOpen) => ({
    width: 18,
    height: 18,
    color: 'red',
    transitionDuration: '0.25s',
    transitionProperty: 'transform',
    transform: isOpen ? 'rotate(0deg)' : 'rotate(180deg)',
  }),

  menuItem: (theme) => ({
    width: '100%',
    my: 0,

    '&:not(:last-child)': {},
    '.MuiTypography-root': {
      color: 'kit.text.h',
    },

    '&.Mui-focusVisible': {
      '.MuiTypography-root': {
        borderBottom: `solid 2px ${theme.palette.kit.text.h}`,
      },
    },

    '&:active': {
      '.MuiTypography-root': {
        fontWeight: 500,
      },
    },

    [theme.breakpoints.up('lg')]: {
      lineHeight: 1.4,
      padding: 0,
    },
  }),

  menuItemLink: {
    display: 'flex',
    alignItems: 'center',
    gap: '8px',
  },

  aiBadge: {
    display: 'flex',
    alignItems: 'center',
    gap: '2px',
    backgroundColor: 'rgba(69, 32, 171, 0.1)',
    borderRadius: '4px',
    padding: '0 5px',
    height: '19px',

    '& > svg': {
      flexShrink: 0,
    },

    '& > .MuiTypography-mobileHelper': {
      fontSize: '11px',
      lineHeight: '120%',
    },
  },

  stackGridItem: (theme) => ({
    [theme.breakpoints.up('sm')]: { marginTop: '4px', marginBottom: '8px' },
    [theme.breakpoints.down('sm')]: { marginBottom: '4px' },
  }),

  stackTitleItem: (theme) => ({
    cursor: 'default',
    fontSize: '14px',
    color: theme.palette.kit.text.main,

    [theme.breakpoints.up('sm')]: {
      marginLeft: '4px',
      paddingBottom: '12px',
    },

    [theme.breakpoints.down('sm')]: {
      paddingBottom: '8px',
    },
  }),
};
